+(function ($) {
    var imageLoader = function(element, options) {
        var self       = this;
        var $element   = $(element);
        var settings   = $.extend({
            onLoad: false,
            onAllStarted: false
        }, options);

        var imageType  = $element.data('background') ? 'bg' : 'img';
        var autoload   = $element.data('imageloader-autoload') || true;
        var imageUrl   = imageType == 'bg' ? $element.data('background') : $element.data('src');
        var timeout    = false;

        this.init = function() {
            if (imageUrl == undefined) {
                return;
            }

            $(window).on('resize', function() {
                if (timeout) {
                    clearInterval(timeout);
                }

                // Only call loadImage() once every 500ms
                timeout = setTimeout(function() {
                    self.loadImage();
                }, 500);
            });

            self.loadImage();
        };

        this.loadImage = function() {
            self.pixelRatio    = window.devicePixelRatio || 1;
            self.elementWidth  = $element.outerWidth();
            self.elementHeight = $element.outerHeight();

            var newWidth       = getSize(self.elementWidth);
            var newHeight      = getSize(self.elementHeight);
            var currentWidth   = $element.data('imageloader-width') || 0;
            var currentHeight  = $element.data('imageloader-height') || 0;

            if (newWidth > currentWidth || newHeight > currentHeight) {
                $element.data({
                    'imageloader-width': newWidth,
                    'imageloader-height': newHeight
                }).addClass('imageloader-loading');

                var imageSizeUrl = imageUrl + (imageUrl.indexOf('?') >= 0 ? '&' : '?') + 'w=' + newWidth + '&h=' + newHeight + '&r=' + self.pixelRatio;
                var image        = new Image();

                if (imageType == 'img') {
                    $element.data('src', imageSizeUrl);
                } else {
                    $element.attr('data-background', imageSizeUrl);
                }

                $(image).on('error load', function() {
                    if (autoload) {
                        if (imageType == 'img') {
                            $element.attr('src', imageSizeUrl);
                        } else {
                            $element.css('background-image', 'url(' + imageSizeUrl + ')');
                        }
                    }

                    if (typeof settings.onLoad == 'function') {
                        settings.onLoad(this);
                    }
                });

                image.src = imageSizeUrl;
            }
        };

        var getSize = function(size) {
			var availableSizes = [200, 300, 480, 768, 992, 1200, 1400, 1800, 2400, 3000, 4000];

			for (var key in availableSizes) {
				if (size <= availableSizes[key]) {
					return availableSizes[key];
				}
			}

			return Math.max(...availableSizes);
        }
    };

    $.fn.imageLoader = function(options) {
        return this.each(function() {
            var loader = new imageLoader(this, options);
            loader.init();
        });
    };
})(jQuery);

